import { View } from 'backbone.marionette';
import { User } from '../../../models';
import './index.styl';

/**
 * @desc League CoreLeagueLadderView Row View Class
 * This class using on league loin page ('fantasy/league/ladder')
 */
export class LadderTeamRow extends View {
	get className() {
		return 'table-row-item';
	}

	initialize() {
		this.league = this.getOption( 'league' );

		this.model
			.set({
				current_user_id: User.get( 'id' ),
				current_round: this.league.get( 'current_round' ),
				selected_round: this.league.get( 'selected_round' ),
				status: this.league.get( 'status' ),
				league: this.league
			})
			.setAvatar()
			.updateLadderData();
	}
}

export default LadderTeamRow;